import React, { Children, cloneElement } from 'react';

import InputLabel from '@components/InputLabel/index';

import useUniqueId from '@hooks/useUniqueId';

import { RadioButtonContainer } from './RadioButtons.style';

export default function RadioButtons({
  children = null,
  selected = '',
  label = '',
  alignment = 'horizontal',
  onChange,
  required = false,
  spacing = '0',
  style,
}: {
  children?: React.ReactNode;
  label?: string;
  alignment?: 'horizontal' | 'vertical' | null;
  onChange?: (value: boolean | number | string) => void;
  selected?: boolean | number | string | null;
  spacing?: string;
  required?: boolean;
  style?: React.CSSProperties;
}) {
  const group = useUniqueId('radio-button-group');

  function handleChange(value: boolean | number | string) {
    if (onChange) {
      onChange(value);
    }
  }

  return (
    <>
      <InputLabel label={label} required={required} />

      <RadioButtonContainer alignment={alignment} style={style}>
        {Children.map(children, (child) =>
          cloneElement(
            child as React.DetailedReactHTMLElement<any, HTMLElement>,
            {
              onClick: handleChange,
              selected,
              alignment,
              group,
              spacing,
            }
          )
        )}
      </RadioButtonContainer>
    </>
  );
}
